import { AfterViewInit, Component, Input } from '@angular/core';
import { ToastComponent } from "../../../../shared/components/toast/toast.component";
import { CommonModule } from "@angular/common";
import { FileUploadEnergyType } from '../../../../core/interfaces/file-upload-interfaces';
import { CalendlyUrl } from '../../../../core/enums/calendly-enums';

declare const Calendly: any;

@Component({
  selector: 'app-invoice-file-dispute-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './invoice-file-dispute-dialog.component.html',
  styleUrl: './invoice-file-dispute-dialog.component.css'
})
export class InvoiceFileDisputeDialogComponent implements AfterViewInit {
  modalDialogId: string = 'invoice_modal_file_dispute'

  isOpen = true;
  isLoading = false;
  isSuccess = false;

  invoice_id: string | null = null;
  toast!: ToastComponent;
  is_review_requested: boolean = false;

  @Input() energyType: FileUploadEnergyType = FileUploadEnergyType.ELECTRICITY;

  constructor() { }

  ngAfterViewInit(): void {
    Calendly.initInlineWidget({
      url: CalendlyUrl.INVOICE_REVIEW,
      parentElement: document.getElementById('calendly-embed'),
      text: 'Schedule time with me',
      color: '#80a7a5',
      textColor: '#ffffff',
      branding: true
    });
  }

  openModal(invoice_id: string, toast: ToastComponent, is_review_requested: boolean, energyType?: FileUploadEnergyType) {
    this.invoice_id = invoice_id;
    this.toast = toast;
    this.is_review_requested = is_review_requested

    if (energyType) {
      this.energyType = energyType;
    }

    let modal = document.getElementById(this.modalDialogId) as HTMLDialogElement;
    modal.showModal();
  }

  closeModal(): void {
    let modal = document.getElementById(this.modalDialogId) as HTMLDialogElement;
    modal.close();
    this.isOpen = false;
    this.isSuccess = false;
  }

  /*
  async bookExpert() {
    if (this.invoice_id == null) {
      return
    }

    if (this.is_review_requested) {
      this.toast.showToast('shared.warning', 'invoice.review_request_warning', 'warning', 5000, true);
      this.closeModal();
      return;
    }

    // Set loading state
    this.isLoading = true;

    try {

      if (this.energyType === FileUploadEnergyType.ELECTRICITY) {
        await lastValueFrom(this.invoiceService.bookElectricityDisputeExpert(this.invoice_id));
      } else if (this.energyType === FileUploadEnergyType.GAS) {
        await lastValueFrom(this.invoiceService.bookGasDisputeExpert(this.invoice_id));
      }

      // API call successful
      this.isLoading = false;
      this.isSuccess = true;
      return
    } catch (error) {
      var crid = 'UNKNOWN-CRID';
      if (error instanceof HttpErrorResponse) {
        crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
      }
      this.toast.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
    }

    this.closeModal()
  }*/
}
